"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_select_search_1 = __importStar(require("react-select-search"));
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const functions_1 = require("@/common/functions");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ open, closeDialog, countries, selectedRegion, onRegionSelect, titleText, guideTextEl, }) {
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog });
    (0, functions_1.useIOSDialogCloseScrollBack)(open);
    const scrollToSelected = (selectedLiIndex) => {
        const scrollUList = document.querySelector('.select-search__options');
        scrollUList.scrollTo({
            // ? 48: select-search__option 하나의 height (고정값)
            // ? 60 : 서치 인풋 height (고정값)
            top: selectedLiIndex * 48 - scrollUList.offsetHeight / 2 + 60,
            behavior: 'smooth',
        });
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(RegionDialog, Object.assign({ open: open }, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, direction: "column", id: "region_guide" }, { children: [(0, jsx_runtime_1.jsxs)("h2", { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/shipping_truck.svg`, css: { width: '20px', height: '20px' } }), titleText] }), (0, jsx_runtime_1.jsx)("h3", { children: guideTextEl })] })), (0, jsx_runtime_1.jsx)(react_select_search_1.default, { printOptions: "always", closeOnSelect: false, value: selectedRegion, onChange: (val) => onRegionSelect(val), options: countries, renderOption: (domProps, option, snapshot, className) => {
                    const typedOption = option;
                    if (snapshot.selected)
                        scrollToSelected(typedOption.index);
                    return ((0, jsx_runtime_1.jsxs)("button", Object.assign({}, domProps, { className: className }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                                    position: 'relative',
                                    flexShrink: 0,
                                    display: 'flex',
                                    width: '20px',
                                    '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '2px' }),
                                } }, { children: (0, jsx_runtime_1.jsx)("img", { css: { width: '100%', borderRadius: '2px' }, loading: "lazy", alt: option.value, src: `https://flagcdn.com/w20/${option.value.toLowerCase()}.webp`, srcSet: `https://flagcdn.com/w40/${option.value.toLowerCase()}.webp 2x` }) })), (0, jsx_runtime_1.jsx)("span", { children: typedOption.name })] })));
                }, search: true, filterOptions: react_select_search_1.fuzzySearch, emptyMessage: t('검색 결과가 없어요.'), placeholder: t('국가명을 입력하세요') }), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, id: "confirm_btn_wrapper" }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "orange_filled", fullWidth: true, onClick: closeDialog, sx: { borderRadius: '12px' } }, { children: t('선택 완료') })) }))] })));
}
exports.default = default_1;
const RegionDialog = (0, styled_1.default)(Dialog_1.default) `
  .MuiDialog-scrollPaper {
    align-items: flex-end;
  }
  .MuiDialog-paper {
    width: 100%;
    max-width: 480px;
    height: 88%;
    padding: 0 20px;
    border-radius: 20px 20px 0 0;
    margin: 0;
    overflow: hidden;
  }
  #region_guide {
    flex-shrink: 0;
    row-gap: 18px;
    width: 100%;
    padding: 20px 0 16px;
    h2 {
      display: flex;
      align-items: center;
      column-gap: 8px;
      line-height: 24px;
      font-weight: 700;
      font-size: 20px;
    }
    h3 {
      display: flex;
      align-items: center;
      column-gap: 5px;
      line-height: 18px;
      font-weight: normal;
      font-size: 15px;
      > span {
        padding: 2px;
        border-radius: 4px;
        background-color: #f8f8f8;
        color: var(--primary-dark);
        line-height: inherit;
        font-weight: bold;
      }
    }
  }
  .select-search {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 20px;
    margin: 0 -20px -20px;
    overflow: hidden;
    box-sizing: border-box;
    *,
    *::after,
    *::before {
      box-sizing: inherit;
    }
  }
  .select-search__value {
    padding: 0 20px 12px;
    background: linear-gradient(
      180deg,
      #ffffff 70%,
      rgba(255, 255, 255, 0.6) 91%,
      rgba(255, 255, 255, 0.1) 100%
    );
    z-index: 1;
  }
  .select-search__input {
    width: 100%;
    height: 48px;
    padding: 0 40px;
    border: 0;
    border-radius: 8px;
    font-size: 15px;
    background-color: #f8f8f8;
    background-image: url('/static/react/src/assets/svgs/search_icon_16x16.svg');
    background-repeat: no-repeat;
    background-position-x: 14px;
    background-position-y: center;
    ::-webkit-search-decoration,
    ::-webkit-search-cancel-button,
    ::-webkit-search-results-button,
    ::-webkit-search-results-decoration {
      -webkit-appearance: none;
    }
  }
  .select-search__select {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 12px 0 20px;
    margin: -12px 0 -20px;
    overflow: hidden;
  }
  .select-search__options {
    display: flex;
    flex-direction: column;
    padding: 12px 0 20px;
    margin: -12px 0 -20px;
    list-style: none;
    overflow-y: auto;
  }
  .select-search__option {
    display: flex;
    align-items: center;
    column-gap: 12px;
    width: 100%;
    height: 48px;
    padding: 0 24px;
    border: none;
    background-color: white;
    :hover {
      background-color: #f8f8f8;
    }
    outline: none;
    font-size: 15px;
    text-align: left;
    cursor: pointer;
  }
  .select-search__option.is-selected {
    background-color: #f8f8f8;
    background-image: url('/static/react/src/assets/svgs/check_icon_orange.svg');
    background-repeat: no-repeat;
    background-position-x: calc(100% - 24px);
    background-position-y: center;
  }
  .select-search__not-found {
    height: auto;
    padding: 14px;
    text-align: center;
    color: #888;
  }
  #confirm_btn_wrapper {
    position: sticky;
    bottom: 0;
    padding: 20px 0;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.6) 12%,
      #ffffff 30%
    );
  }
`;
